import React from 'react';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux';
import FormError from "../FormError";

class BusinessForward extends React.Component {
    componentDidMount() {
        jQuery(jQuery("input.first_compass.null")[0]).focus();
    }
    render() {
        return (
            <div className="col-sm-12 pl-0 pr-0 mt-2">
                <div className="d-flex precanned-item mx-0 px-2">
                    <div className="precanned d-flex filter-bar-wrapper">

                        <div className='w-100 row'>
                            <div className="col-md-4 col-sm-12 nickname mb-3" id={this.props.forward.id ?? null}>
                                {this.props.forward.id &&
                                    <input type="hidden" name={'contact[' +  this.props.forward.id + ']' + '[id]'} value={this.props.forward.id} />
                                }
                                <div className="input-group">
                                    <input type="text" onChange={this.props.changeName.bind(this)}
                                           value={this.props.forward.nickname ?? ""}
                                           name={(this.props.forward.id ? 'contact[' + this.props.forward.id + ']' : 'new_contact[' + this.props.uuid + ']') + '[nickname]'}
                                           onKeyPress={e => {
                                               if (e.key === "Enter") {
                                                   e.preventDefault();
                                               }
                                           }} className="input form-control input-primary label w-100"
                                           placeholder={__('Name')}/>
                                </div>
                            </div>
                            <div className="col-md-4 col-sm-12 email mb-3" id={this.props.forward.id ?? null}>
                                <div className="input-group">
                                    <input type="email" onChange={this.props.changeEmail.bind(this)}
                                           value={this.props.forward.email ?? ""}
                                           name={(this.props.forward.id ? 'contact[' + this.props.forward.id + ']' : 'new_contact[' + this.props.uuid + ']') + '[email]'}
                                           onKeyPress={e => {
                                               if (e.key === "Enter") {
                                                   e.preventDefault();
                                               }
                                           }} className="input form-control input-primary label w-100"
                                           placeholder={__('Email')}/>
                                </div>
                            </div>
                            <div className="col-md-4 col-sm-12 phone mb-3 mr-0" id={this.props.forward.id ?? null}>
                                <div className="input-group">
                                    <input type="tel" onChange={this.props.changeRec.bind(this)}
                                           value={this.props.forward.recipient ?? ""}
                                           name={(this.props.forward.id ? 'contact[' + this.props.forward.id + ']' : 'new_contact[' + this.props.uuid + ']') + '[phone]'}
                                           onKeyPress={e => {
                                               if (e.key === "Enter") {
                                                   e.preventDefault();
                                               }
                                           }}
                                           className={"first_compass input form-control input-primary label w-100 " + this.props.forward.id ?? "null"}
                                           placeholder={__('Phone')}/>
                                </div>
                                <div className="mt-1">
                                    <FormError error_message={this.props.forward.recipient_error}></FormError>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div
                        className="d-flex align-items-center mb-4 justify-content-end justify-content-sm-center precanned-action ml-auto">
                        <a href="#" className="delete" onClick={this.props.delete.bind(this)}><i
                            className="fas fa-times text-dark"></i></a>
                    </div>
                </div>
                <hr className='w-100 mt-0 d-md-none'/>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return { state: state }
}

export default connect(mapStateToProps)(BusinessForward);
